// HelpPointer Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import $ from 'jquery'
import _ from 'lodash'

class HelpPointer extends Component {
  constructor (props) {
    super(props)
    this._resizeHandler = this._resize.bind(this)
  }

  static get propTypes () {
    return {
      type: PropTypes.oneOf([
        'top',
        'right',
        'bottom',
        'left',
        'topright',
        'righttop',
        'rightbottom',
        'bottomright',
        'lefttop',
        'leftbottom'
      ]),
      showActive: PropTypes.bool,
      value: PropTypes.number,
      onClick: PropTypes.func,
      position: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      type: 'top',
      showActive: false,
      value: null,
      onClick: null,
      position: []
    }
  }

  componentDidMount () {
    $(window).on('resize', this._resizeHandler)
  }

  componentWillUnmount () {
    $(window).off('resize', this._resizeHandler)
  }

  _resize () {
    window.setTimeout(this._updateColumnWidth.bind(this), 500)
  }

  _updateColumnWidth () {
    this.forceUpdate()
  }

  _getLocations () {
    const winWidth = window.innerWidth
    const contentWidthPerc = 75
    const pageContWidth = (winWidth * contentWidthPerc) / 100
    const helpContWidth = winWidth - pageContWidth
    const style = {}

    if (this.props.position) {
      this.props.position.map((location) => {
        let left = 0
        if (location && location.left) {
          left = _.split([location.left], '%')
        }

        if (
          location.from >= 320 &&
          location.to <= 767 &&
          location.to !== '' &&
          winWidth < 768
        ) {
          style.left = (pageContWidth * left[0]) / 100 + helpContWidth || 0
          style.top = location.top
        } else if (
          location.from > 767 &&
          location.to <= 1023 &&
          location.to > 767 &&
          location.to !== '' &&
          winWidth < 1024 &&
          winWidth > 767
        ) {
          style.left = (pageContWidth * left[0]) / 100 + helpContWidth || 0
          style.top = location.top
        } else if (location.from >= 1024 && winWidth >= 1024) {
          style.left = (pageContWidth * left[0]) / 100 + helpContWidth || 0
          style.top = location.top
        }
      })
    }

    return style
  }

  render () {
    const _className = classnames('help-pointer', {
      'help-pointer_active': this.props.showActive
    })
    const rotateClassName = `rotator rotator_${this.props.type}`

    const style = this._getLocations()

    return (
      <div className={_className} onClick={this.props.onClick} style={style}>
        <span className={rotateClassName}>&nbsp;</span>
        <span className='value'>{this.props.value}</span>
      </div>
    )
  }
}

export default HelpPointer
